import { put, select, takeLatest } from 'redux-saga/effects'
import { BodySurveyConstants } from '../store/bodySurvey.constants'
import { IBodySurveyState, IExamValue } from '../store/bodySurvey.types'
import { getBodySurveySelector } from '../selectors'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { saveBodySurvey, setExamPNNVValue, setExamValue } from '../store/bodySurvey.actions'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'

export function* deleteExamValue() {
  const bodySurvey: IBodySurveyState = yield select(getBodySurveySelector)

  const { examValues, examValuesPNNVs, __deleteExam } = bodySurvey
  try {
    const filterOptions: IExamValue[] = [...examValues, ...examValuesPNNVs]
    let updatedOptions: IExamValue[] = []
    if (Array.isArray(__deleteExam)) {
      updatedOptions = filterOptions.filter((exam) => !__deleteExam.some((deleteExam) => deleteExam.id === exam.id))
    } else {
      if (__deleteExam) {
        if (__deleteExam.originalLocationIds) {
          updatedOptions = filterOptions.filter((exam) =>
            __deleteExam.originalLocationIds.every((loc) => exam.id !== loc.optionId)
          )
        } else {
          updatedOptions = filterOptions.filter((exam) =>
            exam.locationId === 12 || exam.locationId === 13
              ? exam.customCommandFacId !== __deleteExam.id
              : exam.id !== __deleteExam.id
          )
        }
      }
    }

    const separateExamValues = updatedOptions.filter((option) => option.segmentId === 1)
    const separateExamPnnvValues = updatedOptions.filter((option) => option.segmentId === 2)

    yield put(setExamValue(separateExamValues))
    yield put(setExamPNNVValue(separateExamPnnvValues))

    yield put(saveBodySurvey())
  } catch (e) {
    yield put(throwPcrException(`deleteExamValue() error: ${e}`))
  }
}

export function* deleteExamValueSaga() {
  yield takeLatest([BodySurveyConstants.DELETE_BODY_SURVEY_EXAM], performWithMutexHOG, deleteExamValue)
}
